import React, { Component } from "react";
import { connect } from "react-redux";

//MUI
import { withStyles } from "@material-ui/core/styles";

//Pages
import UserDashboard from "./user_dashboard/UserDashboard";
import ClientDashboard from "./client_dashboard/ClientDashboard";
import DefaultDashboard from "./default_dashboard/DefaultDashboard";

function mapStateToProps(state) {
  return {
    email: state.user.currentUser.profile.email,
    name: state.user.currentUser.profile.name,
    role: state.user.currentUser.role
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch
  };
}

const styles = theme => ({
  root: {
    flexGrow: 1
  }
});

class DashboardRouter extends Component {
  render() {
    const { classes, role } = this.props;
    return (
      <div className={classes.root}>
        {role === "client" ? (
          <ClientDashboard {...this.props} />
        ) : role === "user" ? (
          <UserDashboard {...this.props} />
        ) : (
          <DefaultDashboard {...this.props} />
        )}
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(DashboardRouter));



// WEBPACK FOOTER //
// ./src/pages/DashboardRouter.js